import React from "react";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ContainerModal } from "../container/ContainerModal";
import { logout } from "../../redux/slices/auth/authAction";
import { useReduxUI } from "../../hooks/redux/useReduxUI";

export const ModalCloseSession = ({ setOpenModal }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { toggledSesionModal } = useReduxUI();


    return (
        <div className="fixed top-0 left-0 w-screen h-svh z-[100] bg-black bg-opacity-45 flex justify-center items-center px-4">
            <ContainerModal
                title={"Cerrar sesión"}
                actionButton={() => {
                    setOpenModal();
                }}
                className={"w-[500px]"}
            >
                <div>
                    <p className="text-[12px]">¿Estas seguro de cerrar sesión?</p>
                    <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
                        <Button
                            onClick={() => {
                                dispatch(logout(navigate));
                                toggledSesionModal()
                            }}
                            type="primary"
                            className="bg-primaryTwo"
                        >
                            Salir
                        </Button>
                    </div>
                </div>
            </ContainerModal>
        </div>
    );
};
